import {Component, computed, input, signal, inject} from '@angular/core';
import {
  PhaseStatusView,
  TenderStatus,
  ProviderTenderControllerService,
  TenderPhaseType,
} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../../shared/components/loading/loading.component';
import {Card} from 'primeng/card';
import {TenderDescriptionRfqComponent} from '../../../../tender-wizard/rfq/tender-description-rfq/tender-description-rfq.component';
import {TenderDescriptionRfiComponent} from '../../../../tender-wizard/rfi/tender-description-rfi/tender-description-rfi.component';
import {TenderDescriptionComponent} from '../../../../tender-wizard/components/tender-description/tender-description.component';
import {IconButtonDialogComponent} from '../../../../../../shared/components/dialog/icon-button-dialog/icon-button-dialog.component';
import {
  getProviderPhaseIcon,
  getProviderPhaseStatusKey,
} from '../../../../../../shared/constants/provider-phase.constants';

@Component({
  selector: 'app-tender-project-description-button',
  imports: [
    LoadingComponent,
    Card,
    TenderDescriptionRfqComponent,
    TenderDescriptionRfiComponent,
    TenderDescriptionComponent,
    IconButtonDialogComponent,
  ],
  templateUrl: './tender-project-description-button.component.html',
})
export class TenderProjectDescriptionButtonComponent {
  readonly colorClass = input.required<string>();
  readonly phaseStatusInfo = input.required<PhaseStatusView>();
  readonly tenderId = input.required<number>();
  private readonly providerTenderService = inject(ProviderTenderControllerService);

  protected readonly dialogOpened = signal(false);

  protected readonly icon = computed(() => getProviderPhaseIcon(this.phaseStatusInfo().status));

  protected readonly statusKey = computed(() =>
    getProviderPhaseStatusKey(this.phaseStatusInfo().status),
  );

  protected readonly hasProjectDescription = computed(() => {
    return !!this.phaseStatusInfo().status && this.phaseStatusInfo().status !== TenderStatus.LOST;
  });

  protected readonly tenderDetailsResource = rxResource({
    params: () => {
      if (!this.dialogOpened()) return undefined;
      return {
        tenderId: this.tenderId(),
        tenderPhase: this.phaseStatusInfo().phase,
      };
    },
    stream: ({params: request}) => this.providerTenderService.getTenderDetails(request!),
  });

  protected readonly TenderPhaseType = TenderPhaseType;
}
